module.exports = __webpack_public_path__ + "img/bg.c569c5d2.jpg";